import React , {useState , useEffect} from 'react';
import { motion } from 'framer-motion';
import './partner.css';
import img1 from '../../../assets/images/flipkart.png';
import img2 from '../../../assets/images/shiprocket.png';
import img3 from '../../../assets/images/ecom.png';
import img4 from '../../../assets/images/lenskart.png';
import img5 from '../../../assets/images/zepto.png';
import img6 from '../../../assets/images/dtdc.png';
import img7 from '../../../assets/images/bluedart.png';
import { useSelector } from 'react-redux';
const Partner = ({source}) => {
  const data  = useSelector((store) => store.data.HomeData);
  const [cardData , setCardData] = useState({})
  const [cardTitle , setCardTitle] = useState('')
  // const cards = [
  //   {  gradientStart: '#F0CB77', gradientEnd: '#D29B1A', icon: img1  },
  //   {  gradientStart: '#9BEFD3', gradientEnd: '#0E9B6C', icon: img2  },
  //   {  gradientStart: '#E3D883', gradientEnd: '#B9A50F', icon: img3  },
  //   {  gradientStart: '#7AD0B4', gradientEnd: '#078058', icon: img4  },
  //   {  gradientStart: '#A4E2A0', gradientEnd: '#1A9A11', icon: img5  },
  //   {  gradientStart: '#98D2DB', gradientEnd: '#13AAC1', icon: img6  },
  //   {  gradientStart: '#D6E4A0', gradientEnd: '#8FAB1F', icon: img7  },
  // ];

  useEffect(() => {
    if (data?.items) {
      const clientSection = data.items.find((ele) => ele.Section === "Clients");
      if (clientSection) {
        setCardData(clientSection.Content);
        setCardTitle(clientSection.Title);
      }
    }
  }, [data]);
  

  const bgColor = source === "about" ? "#fff" : ""; 
  const textColor = source === "about" ? "#000" : "#fff"; 
  
  return (
    <div className="parnter-page-wrapper" style={{ background: bgColor, color: textColor }}>
      <motion.h2 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="heading1 capitalize-first-letter"
        style={{ color: textColor }}
      >
        { cardTitle ? cardTitle : "Join the league of legends!" }
      </motion.h2>

      <div className="cards-container1" >
        {cardData?.Client?.map((card, index) => (
          <motion.div 
            key={index} 
            className="card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            style={{
                background: `linear-gradient(to bottom right, ${card.GradientStart}, ${card.GradientEnd})`}}
          >
            <img src={card.OrgLogo} alt="Not Found" />           
          </motion.div>
        ))}
      </div>
    </div>
  );

}

export default Partner;
